var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup43(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 56,
    viewBox: "0 0 64 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 55.3257H0V0H64V55.3257ZM1.40351 53.9215H62.5965V1.40421H1.40351V53.9215Z",
    fill: "#209BB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8245 0.673828H16.421V54.5954H17.8245V0.673828Z",
    fill: "#209BB7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6562 0.72998H32.2527V54.6516H33.6562V0.72998Z",
    fill: "#209BB7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.786 0.72998H47.3824V54.6516H48.786V0.72998Z",
    fill: "#209BB7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1859 14.2949H0.870117V15.6991H63.1859V14.2949Z",
    fill: "#209BB7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1299 27.3257H0.814087V28.7299H63.1299V27.3257Z",
    fill: "#209BB7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1299 39.627H0.814087V41.0312H63.1299V39.627Z",
    fill: "#209BB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup43);
export default __webpack_public_path__ + "static/media/Group43.5f09db050ef4415a4aaaeadef3ca4a4f.svg";
export { ForwardRef as ReactComponent };